module.exports = __webpack_public_path__ + "img/ats.48802a78.svg";